import { ApiView } from '@e3dc-react/shell/Elements/ApiView'
import { Paper } from '@e3dc-react/shell/Elements/Paper'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'
import { Installation } from 'src/Libs/installations/models'
import { useUserInstallationsTableData } from '../hooks'

interface UserOwnedInstallationsProps {
  userId: string
}

/**
 * List of all installations owned by a user
 */
const UserOwnedInstallations: React.FC<UserOwnedInstallationsProps> = ({ userId }) => {
  const { t } = useCustomTranslation()
  const { columns, fetchProps, listProps } = useUserInstallationsTableData(userId)

  return (
    <Paper title={<Typography variant={'h3'}>{t('service-dashboard.users.owned-installations.title')}</Typography>}>
      <Box>
        <ApiView<Installation>
          fetchProps={fetchProps}
          customPayload={{ accountLinkFilter: `accountId=${userId}` }}
          tableColumns={columns}
          isMobilePaginator={true}
          hasColoredTableColumns
          bodyElevation={0}
          footerElevation={0}
          headerElevation={0}
          listProps={listProps}
          listElevation={0}
          noData={t('service-dashboard.users.owned-installations.no-data')}
        />
      </Box>
    </Paper>
  )
}

export default UserOwnedInstallations
